import { View } from 'react-native';
import { useTheme } from '@/theme';
import { ThemedText, Caption } from '@/components/ui/Text';
import { LinearGradient } from 'expo-linear-gradient';

type OnboardingProgressProps = {
  currentStep: number;
  totalSteps: number;
  showProgressBar?: boolean;
};

export function OnboardingProgress({
  currentStep,
  totalSteps,
  showProgressBar = true,
}: OnboardingProgressProps) {
  const theme = useTheme();
  const progress = currentStep / totalSteps;

  return (
    <View
      style={{
        paddingHorizontal: theme.spacing(2),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1.5),
        gap: theme.spacing(1),
      }}
    >
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Caption color={theme.colors.textSecondary} style={{ fontSize: 13, fontWeight: '500' }}>
          Step {currentStep} of {totalSteps}
        </Caption>
      </View>
      {showProgressBar && (
        <View
          style={{
            height: 3,
            backgroundColor: theme.colors.borderMuted,
            borderRadius: 1.5,
            overflow: 'hidden',
          }}
        >
          <LinearGradient
            colors={[theme.colors.primary, theme.colors.primary]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 0 }}
            style={{
              height: '100%',
              width: `${progress * 100}%`,
              borderRadius: 1.5,
            }}
          />
        </View>
      )}
    </View>
  );
}















